/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompleteLEvLEIRequest
 */
export interface CompleteLEvLEIRequest {
    /**
     * 
     * @type {string}
     * @memberof CompleteLEvLEIRequest
     */
    multisigAid: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompleteLEvLEIRequest
     */
    larsAids: Array<string>;
}

/**
 * Check if a given object implements the CompleteLEvLEIRequest interface.
 */
export function instanceOfCompleteLEvLEIRequest(value: object): boolean {
    if (!('multisigAid' in value)) return false;
    if (!('larsAids' in value)) return false;
    return true;
}

export function CompleteLEvLEIRequestFromJSON(json: any): CompleteLEvLEIRequest {
    return CompleteLEvLEIRequestFromJSONTyped(json, false);
}

export function CompleteLEvLEIRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteLEvLEIRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'multisigAid': json['multisigAid'],
        'larsAids': json['larsAids'],
    };
}

export function CompleteLEvLEIRequestToJSON(value?: CompleteLEvLEIRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'multisigAid': value['multisigAid'],
        'larsAids': value['larsAids'],
    };
}

